import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getResourceAuthorization } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'
import { getCombiCollectionAmount, getLastThreeUnexpelledPolicies } from '@verzekeringapp-mono/shared/src/state/selectors/policies'
import PolicySummaryRow from '~/components/PolicySummaryRow'

const currency = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })

const MyPoliciesCard: React.FC = () => {
  const resourceAuthorization = useAppSelector(getResourceAuthorization)
  const policies = useAppSelector(getLastThreeUnexpelledPolicies)
  const combiCollectionAmount = useAppSelector(getCombiCollectionAmount)
  const relationInfo = resourceAuthorization?.relationInfo

  return (
    <section
      aria-labelledby='home-policies-title'
      className='xl:col-span-2 rounded-lg border border-border-subtle bg-surface-card p-6'
    >
      <div className='flex flex-wrap items-start justify-between gap-4 pb-7'>
        <div>
          <h2
            id='home-policies-title'
            className='font-semibold'
          >Mijn verzekeringen</h2>

          <p className='mt-1 text-sm'>Combinummer: {resourceAuthorization?.combiNumber}</p>
        </div>

        <div className='ml-auto text-right'>
          <p className='font-semibold text-text-brand'>{currency.format(Number(combiCollectionAmount))}</p>

          <p className='mt-1 text-sm'>
            {relationInfo?.paymentPeriod && `per ${relationInfo.paymentPeriod.toLowerCase()}`}

            {!!relationInfo?.combiPackageDiscount && (
              <>
                {relationInfo.paymentPeriod && ', '}

                incl. {Intl.NumberFormat('nl-NL', { style: 'percent' }).format(Number(relationInfo.combiPackageDiscount) / 100)} korting
              </>
            )}
          </p>
        </div>
      </div>

      <ul className='divide-y divide-border-subtle border-y border-border-subtle'>
        {policies.map(policy => (
          <li key={policy.id}>
            <PolicySummaryRow policy={policy} />
          </li>
        ))}
      </ul>

      <Link
        className='mt-5 flex items-center justify-end gap-4 px-3 py-1'
        to='/verzekeringen'
      >
        <span className='text-sm underline'>Bekijk volledig pakket</span>

        <FontAwesomeIcon
          icon={faChevronRight}
          className='text-icon-secondary'
        />
      </Link>
    </section>
  )
}

export default MyPoliciesCard
